module.exports = __webpack_public_path__ + "f9043c9b5666228b526ba9239db6cb5a.fbx";